import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../hooks/auth/useAuth";
import { authContextType } from "../@types/auth-types";
import { useTeachersData } from "../hooks/teacher/useTeachersData";
import BackgroundLogo from "../components/background-logo";
import "../styles/pages/edit-student.css";
import "../styles/pages/new-teacher.css"; // Add this import
import "../styles/pages/edit-teacher.css";
import api from "../util/api";
import { ImArrowLeft2, ImArrowRight2 } from "react-icons/im";

function EditTeacher() {
  const navigate = useNavigate();
  const { teacherId } = useParams();
  const { user } = useAuth() as authContextType;
  const { data: teachers } = useTeachersData(user.userId, user.token);

  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    "user1.png",
    "user2.png",
    "user3.png",
    "user4.png",
    "user5.png",
    "user6.png",
    "user7.png",
  ];

  const handlePreviousImage = () => {
    setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
    setSelectedImage(images[currentImageIndex > 0 ? currentImageIndex - 1 : images.length - 1]);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
    setSelectedImage(images[currentImageIndex < images.length - 1 ? currentImageIndex + 1 : 0]);
  };

  useEffect(() => {
    const teacher = teachers?.find(t => t.id === teacherId);
    if (teacher) {
      setNome(teacher.name);
      setEmail(teacher.email || "");
      setSelectedImage(teacher.image || "");
      const index = images.findIndex(img => img === teacher.image);
      setCurrentImageIndex(index >= 0 ? index : 0);
    }
  }, [teachers, teacherId]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      api.defaults.headers.authorization = user.token;

      await api.patch(`/professor/${teacherId}`, {
        name: nome,
        email: email,
        image: selectedImage
      });

      navigate("/professores");
    } catch (err: any) {
      const message = err.response?.status === 403
        ? "Não autorizado. Por favor, faça login novamente."
        : "Erro ao atualizar professor";
      setError(message);
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleComeBack = () => {
    navigate("/professores");
  };

  return (
    <div className="background-edit-teacher">
      <BackgroundLogo isAdminPage={false} />
      <div className="background-right-edit-teacher">
        <div className="content-edit-teacher">
          <label className="label-title-new-student">Editar Professor</label>

          <label className="label-new-student">Nome</label>
          <input
            type="text"
            name="nome"
            className="input-new-student"
            placeholder="Digite o Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />

          <label className="label-new-student">Email</label>
          <input
            type="email"
            name="email"
            className="input-new-student"
            placeholder="Digite o Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label className="label-new-student">Imagem do Professor</label>
          <div className="images-navigation-container">
            <ImArrowLeft2
              size={25}
              className="arrow-button"
              onClick={handlePreviousImage}
            />
            <div className="single-image-container">
              <img
                src={require(`../assets/teachers/${images[currentImageIndex]}`)}
                alt={`Teacher ${currentImageIndex + 1}`}
                className={selectedImage === images[currentImageIndex] ? "selected" : ""}
                onClick={() => setSelectedImage(images[currentImageIndex])}
              />
            </div>
            <ImArrowRight2
              size={25}
              className="arrow-button"
              onClick={handleNextImage}
            />
          </div>

          {error && <label className="label-error-new-student">{error}</label>}

          <div className="buttons-container-new-student"></div>
            <input
              type="button"
              value="Voltar"
              className="button-go-back-new-student"
              onClick={handleComeBack}
            />
            <input
              type="submit"
              value={isLoading ? "Salvando..." : "Salvar"}
              className="button-new-student"
              onClick={handleSubmit}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
  );
}

export default EditTeacher;